import { Link, useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/lenis";

export function useSectionNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (id) => {
    if (pathname === "/") scrollToId(id);
    else navigate(`/#${id}`);
  };
}

export const NavLinkItem = ({ link, className, onDone }) => {
  const go = useSectionNav();
  if (link.route) {
    return (
      <Link to={link.route} onClick={onDone} className={className} data-testid={`nav-link-${link.id}`}>
        {link.label}
      </Link>
    );
  }
  return (
    <a
      href={`/#${link.id}`}
      onClick={(e) => {
        e.preventDefault();
        onDone?.();
        go(link.id);
      }}
      className={className}
      data-testid={`nav-link-${link.id}`}
    >
      {link.label}
    </a>
  );
};
